"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var protocol_http_1 = require("@aws-sdk/protocol-http");

var CONTENT_LENGTH_HEADER = "content-length";

function contentLengthMiddleware(bodyLengthChecker) {
  var _this = this;

  return function (next) {
    return function (args) {
      return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var request, body, headers, length;

        var _a;

        return tslib_1.__generator(this, function (_b) {
          request = args.request;

          if (protocol_http_1.HttpRequest.isInstance(request)) {
            body = request.body, headers = request.headers;

            if (body && Object.keys(headers).map(function (str) {
              return str.toLowerCase();
            }).indexOf(CONTENT_LENGTH_HEADER) === -1) {
              length = bodyLengthChecker(body);

              if (length !== undefined) {
                request.headers = tslib_1.__assign(tslib_1.__assign({}, request.headers), (_a = {}, _a[CONTENT_LENGTH_HEADER] = String(length), _a));
              }
            }
          }

          return [2
          /*return*/
          , next(tslib_1.__assign(tslib_1.__assign({}, args), {
            request: request
          }))];
        });
      });
    };
  };
}

exports.contentLengthMiddleware = contentLengthMiddleware;
exports.contentLengthMiddlewareOptions = {
  step: "build",
  tags: ["SET_CONTENT_LENGTH", "CONTENT_LENGTH"],
  name: "contentLengthMiddleware"
};

exports.getContentLengthPlugin = function (options) {
  return {
    applyToStack: function applyToStack(clientStack) {
      clientStack.add(contentLengthMiddleware(options.bodyLengthChecker), exports.contentLengthMiddlewareOptions);
    }
  };
};